// src/utils/currency-constants.tsx
var SUPPORTED_CURRENCIES = [
  {
    code: "USD",
    decimals: 2,
    stripeDecimals: 2
  },
  {
    code: "EUR",
    decimals: 2,
    stripeDecimals: 2
  },
  {
    code: "GBP",
    decimals: 2,
    stripeDecimals: 2
  },
  {
    code: "JPY",
    decimals: 0,
    stripeDecimals: 0
  },
  {
    code: "INR",
    decimals: 2,
    stripeDecimals: 2
  },
  {
    code: "AUD",
    decimals: 2,
    stripeDecimals: 2
  },
  {
    code: "CAD",
    decimals: 2,
    stripeDecimals: 2
  }
];
export {
  SUPPORTED_CURRENCIES
};
//# sourceMappingURL=currency-constants.js.map